module.exports = __webpack_public_path__ + "static/media/Hero_Image_Desktop_1.d9382216.jpg";